import React, {useState} from 'react';
import {Navigate, useLocation, useNavigate} from 'react-router-dom';
import Title from "../components/Title";
import Button from "../components/Button";
import Separator from "../components/Separator";
import {useAuth} from "../context/AuthContext";

const Login = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const {user, login} = useAuth();
    const [loginValue, setLoginValue] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    if (user) {
        const redirectPath = location.state?.from?.pathname || '/';
        return <Navigate to={redirectPath} replace/>;
    }

    const handleSubmit = async () => {
        setError('');
        setIsSubmitting(true);

        try {
            const authUser = await login(loginValue, password);
            navigate(authUser.role === 'admin' ? '/g45awer/users' : '/', {replace: true});
        } catch (submitError) {
            setError(submitError.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="wrap auth_page">
            <Title title={"Login"}/>
            <Separator/>
            <label className="form auth_form">
                <input
                    type="text"
                    placeholder="Login"
                    value={loginValue}
                    autoComplete="username"
                    onChange={(e) => setLoginValue(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    autoComplete="current-password"
                    onChange={(e) => setPassword(e.target.value)}
                />
            </label>
            {error && <p className="auth_error">{error}</p>}
            <Button
                text={isSubmitting ? "Logging in..." : "Login"}
                primary={true}
                disabled={isSubmitting || !loginValue.trim() || !password}
                handleClick={handleSubmit}
            />
        </div>
    );
};

export default Login;
